import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppPersistantStateService, StoreNames } from 'core/state/app-state.service';
import { AppStateStorage } from 'core/state/app-state-storage';
import { isMobileDevice, isPWA } from 'helpers';
import { PWADialogComponent } from 'app/main/components/pwa-dialog/pwa-dialog.component';

@Component({
  selector: 'app-header-switch',
  templateUrl: './header-switch.component.html',
})
export class HeaderSwitchComponent implements OnInit {
  @Input() headerType: string;

  constructor(
    private appPersistantStateService: AppPersistantStateService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    // testing...
    console.log('hide pwa notice?... ' + localStorage.getItem('hide-pwa-notice'));
    // uncomment the following if more testing of the pwa notice is necessary
    // localStorage.removeItem('hide-pwa-notice');
  }

  // Determines whether or not to show the PWA (Progressive Web App) Notice
  // ...which contains the button that launches the modal with instructions
  // for installing the "app".
  pwaNoticeIsVisible(): boolean {
    const hidePWANotice = localStorage.getItem('hide-pwa-notice');
    if(hidePWANotice === 'true') {
      return false;
    }

    return isMobileDevice() && !isPWA();
  }

  onDismissPWANoticeClick() {
    localStorage.setItem('hide-pwa-notice', 'true');
  }

  onOpenPWAModalClick() {
    const panelClass = 'support-dialog';
    this.dialog.open(PWADialogComponent, {
      panelClass
    })
  }

  usingSkinnyNavBool() {
    const appStorage = new AppStateStorage();
    return (appStorage.read(StoreNames.UseSkinnyNav) === 'true');
  }

  toggleSkinnyNav() { 
    if(this.usingSkinnyNavBool()) {
      this.document.body.classList.remove('use-skinny-nav');
      this.appPersistantStateService.update(StoreNames.UseSkinnyNav, 'false');
    } else {
      this.document.body.classList.add('use-skinny-nav');
      this.appPersistantStateService.update(StoreNames.UseSkinnyNav, 'true');
    }
  }
}
